import React, { useState } from 'react';
import '../../../../../Stylesheets/Dashboard/EditProjectModal.css';
import { useDispatch } from 'react-redux';
import { updateProjectDetails } from '../../../../../Redux/Projects/projectSlice';
import { toast } from 'react-toastify';



const EditProjectModal = ({ project, onClose }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    name: project.name || '',
    startDate: project.startDate?.split('T')[0] || '',
    endDate: project.endDate?.split('T')[0] || '',
    budget: project.budget || '',
    location: project.location || '',
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
     await dispatch(updateProjectDetails({ id: project._id, updates: formData })).unwrap();
      toast.success('Project updated successfully!');
      onClose();
    } catch (err) {
      toast.error(err || 'Failed to update project');
    }
  };

  return (
    <div className="edit-project-overlay">
      <div className="edit-project-modal">
        <h2>Edit Project</h2>
        <form onSubmit={handleSubmit} className="edit-project-form">
          <label>Project Name</label>
          <input name="name" value={formData.name} onChange={handleChange} required />

          <label>Start Date</label>
          <input type="date" name="startDate" value={formData.startDate} onChange={handleChange} required />

          <label>End Date</label>
          <input type="date" name="endDate" value={formData.endDate} onChange={handleChange} required />

          <label>Budget (INR)</label>
          <input name="budget" value={formData.budget} onChange={handleChange} required />

          <label>Location</label>
          <input name="location" value={formData.location} onChange={handleChange} required />

          <div className="edit-project-actions">
            <button type="button" onClick={onClose} className="cancel-btn-edit">Cancel</button>
            <button type="submit" className="save-btn-edit">Save</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditProjectModal;
